import { Footer } from "antd-mobile";

const MyFooterM = () =>{
    return (
        <Footer style={{backgroundColor: '#f5f5f5'}} content={<a href={'https://beian.miit.gov.cn'} target='_blank' rel='noopener noreferrer'>渝ICP备19006914号-1</a>}>
        </Footer>
    )
}

export default MyFooterM